import React, {Component} from 'react';


import CircularProgress from "material-ui/CircularProgress";
import Dialog from 'material-ui/Dialog';

import _ from "underscore";

import "../../css/LocationDetail.css";
import "../../css/LocationDetailPrint.css";
import "../../css/font-awesome.css";
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import Tracker from '../common/Tracker';
import DetailTitlePanel from './details/DetailTitlePanel'
import ContactInfoPanel from './details/ContactInfoPanel'
import LocationHoursTable from './details/LocationHoursTable';
import QuickFactsPanel from './details/QuickFactsPanel';
import AmenitiesPanel from './details/AmenitiesPanel';
import DetailMapWidget from './details/DetailMapWidget';
import MedicationsAvailableDetailWidget from './details/MedicationsAvailableDetailWidget';
import ShareLocationForm from './details/ShareLocationForm'
import ContactInfusionCenterForm from './details/ContactInfusionCenterForm'
import ResponsiveLayout from '../common/ResponsiveLayout';
import attributeIds from "../../api/attributeIds";
import api from "../../api/api.js"
import styles from "./styles";
import FullscreenPopover from '../common/FullscreenPopover';

const CATEGORY = "location details";

class LocationDetailDesktopLayout extends Component {
    render() {
        return (
            <div className="locationDetail" >
                <DetailTitlePanel
                    location={this.props.getLocation()}
                    onSelectionCleared={this.props.onSelectionCleared}
                    onBackClick={this.props.onBackClick} />

                <div className="detailContent">
                    <ContactInfoPanel
                        location={this.props.getLocation()}
                        showContactCenterDialog={this.props.onToggleContactCenterDialog}
                        showShareLocationDialog={this.props.onToggleShareLocationDialog}/>

                    {this.props.getLocation().description ?
                        <div className="locationDetailDescription minPadded">
                            {this.props.getLocation().description}
                        </div>
                        :
                        null
                    }

                    <div className="container horizontal" >
                        <LocationHoursTable location={this.props.getLocation()}/>
                        <DetailMapWidget location={this.props.getLocation()}/>
                    </div>

                    <MedicationsAvailableDetailWidget
                                          location={this.props.getLocation()}
                                          medicationsAvailable={this.props.medicationsAvailable}
                                          practiceSpecialty={this.props.practiceSpecialty}/>

                    <div className="container factsAndAmenities">

                        <div className="container flex3 minPadded" style={{backgroundColor: styles.blue}}>
                            <QuickFactsPanel location={this.props.getLocation()} attributes={this.props.allAttributes}/>
                        </div>

                        <div className="container flex2 minPadded" style={{backgroundColor: styles.white}}>
                            <AmenitiesPanel location={this.props.getLocation()} attributes={this.props.allAttributes}/>
                        </div>

                      </div>
                </div>
                <Dialog
                    open={this.props.showContactCenterDialog}
                    modal={false}
                    autoScrollBodyContent={true}
                    contentStyle={{width: "90%"}}
                    onRequestClose={this.props.onToggleContactCenterDialog}>
                    <ContactInfusionCenterForm location={this.props.getLocation()} onClose={this.props.onToggleContactCenterDialog}/>
                </Dialog>
                <Dialog
                    open={this.props.showShareLocationDialog}
                    modal={false}
                    autoScrollBodyContent={true}
                    contentStyle={{width: "90%"}}
                    onRequestClose={this.props.onToggleShareLocationDialog}>
                    <ShareLocationForm open={this.props.showShareLocationDialog} location={this.props.getLocation()} onClose={this.props.onToggleShareLocationDialog}/>
                </Dialog>
            </div>
        )
    }
}

class LocationDetailMobileLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div className="locationDetail">
                <DetailTitlePanel
                    location={this.props.getLocation()}
                    onSelectionCleared={this.props.onSelectionCleared}
                    onBackClick={this.props.onBackClick} />
                <ContactInfoPanel
                    location={this.props.getLocation()}
                    showContactCenterDialog={this.props.onToggleContactCenterDialog}
                    showShareLocationDialog={this.props.onToggleShareLocationDialog}/>
                {this.props.getLocation().description ?
                    <div className="locationDetailDescription minPadded">
                        {this.props.getLocation().description}
                    </div>
                    :
                    null
                }
                <LocationHoursTable location={this.props.getLocation()}/>
                <div style={{height: "250px", position: "relative", display: "flex"}}>
                    <DetailMapWidget location={this.props.getLocation()}/>
                </div>
                <MedicationsAvailableDetailWidget
                                      location={this.props.getLocation()}
                                      medicationsAvailable={this.props.medicationsAvailable}
                                      practiceSpecialty={this.props.practiceSpecialty} />
                <div className="minPadded" style={{backgroundColor: "#1c5c7f"}}>
                    <QuickFactsPanel location={this.props.getLocation()} attributes={this.props.allAttributes}/>
                </div>
                <div className="minPadded" style={{backgroundColor: "#ffffff"}}>
                    <AmenitiesPanel location={this.props.getLocation()} attributes={this.props.allAttributes}/>
                </div>
                {this.props.showContactCenterDialog ?
                    <FullscreenPopover
                        open={this.props.showContactCenterDialog}
                        location={this.props.getLocation()}
                        onClose={this.props.onToggleContactCenterDialog}
                        childClass={ContactInfusionCenterForm} />
                    :
                    null
                }
                {this.props.showShareLocationDialog ?
                    <FullscreenPopover
                        open={this.props.showShareLocationDialog}
                        location={this.props.getLocation()}
                        onClose={this.props.onToggleShareLocationDialog}
                        childClass={ShareLocationForm} />
                    :
                    null
                }
            </div>
        );
    }
}

class LocationDetail extends Component {

    constructor(props){
        super(props);
        this.state = {
            location: null,
            medicationsAvailable: false,
            practiceSpecialty: false,
            allAttributes: false,
            showContactCenterDialog: false,
            showShareLocationDialog: false,
            animateOut: false,
        }
    }

    componentWillMount(){
        Tracker.trackPageView("/locator/location/" + this.props.locationKey);
        api.trackLocationDetailView(this.props.locationKey);

        if(this.props.locationKey){
            api.locationByKey(this.props.locationKey, (location)=>{
                this.setState({location: location});
            });
        }
        // if(this.props.location){
        //     this.setState({location: this.props.location});
        // }

        api.getAttributes((attributes) =>{
            var formattedAttributes = {};
            var medicationsAvailable = _.findWhere(attributes, {key: attributeIds.medicationsAvailable});
            var practiceSpecialty = _.findWhere(attributes, {key: attributeIds.practiceSpecialty});
            this.formatMedicationsAvailable(medicationsAvailable);
            this.formatPracticeSpecialty(practiceSpecialty);
            attributes.forEach(attr => {
                formattedAttributes[attr.key] = attr;
            });
            // console.log("formatted attributes: %o", formattedAttributes);
            this.setState({allAttributes: formattedAttributes})

        });
    }

    getLocation = () => {
        if (this.state.location) {
            return this.state.location
        }
        return this.props.location
    }

    formatMedicationsAvailable(response){
        var medicationsAvailable = {icon: response.icon, options: []}
        for (var id in response.groups) {
            if (response.groups[id]) {
                var group = response.groups[id];
                for (var optionId in group.options) {
                    if (group.options[optionId]) {
                        var option = {...group.options[optionId], optionId: optionId, groupId: id}
                        medicationsAvailable.options.push(option);
                    }
                }
            }
        }
        this.setState({medicationsAvailable: medicationsAvailable});

    }

    formatPracticeSpecialty(response) {
        var practiceSpecialty = {icon: response.icon, options: []}
        for(var id in response.options){
            if (response.options[id]) {
                var option = {...response.options[id], optionId: id}
                practiceSpecialty.options.push(option);
            }
        }
        this.setState({practiceSpecialty: practiceSpecialty})

    }

    isLoading = () => {
        return !_.every([this.getLocation(), this.state.medicationsAvailable, this.state.practiceSpecialty, this.state.allAttributes] )
    }

    onToggleContactCenterDialog = () => {
        // console.log("what");
        Tracker.trackEvent(CATEGORY, "toggle contact form", this.state.showContactDialog ? "hide" : "show");
        this.setState((prevState)=>{
            return {showContactCenterDialog: !prevState.showContactCenterDialog}
        });

    }

    onToggleShareLocationDialog = () => {
        Tracker.trackEvent(CATEGORY, "toggle share form", this.state.showShareLocationDialog ? "hide" : "show");
        this.setState((prevState)=>{
            return {showShareLocationDialog: !prevState.showShareLocationDialog}
        });

    }

    onBackClick = () => {
        Tracker.trackEvent(CATEGORY, "back click", "", "");

        // console.log("onBackClick");
        this.setState({animateOut: true});
        window.setTimeout(() => {
            // console.log("get ridda dat ish");
            document.location.href = "/#";
        }, 500)
    }

    render() {
        return (
            <div className={"locationDetailWrapper" + (this.state.animateOut ? " locationDetailWrapperExit" : "")} >
                {this.isLoading() ?
                    <div className="detailLoading">
                        <CircularProgress size={50} thickness={5} />
                    </div>
                    :
                    <ResponsiveLayout
                        desktopLayout={LocationDetailDesktopLayout}
                        mobileLayout={LocationDetailMobileLayout}
                        {...this.state}
                        {...this.props}
                        getLocation={this.getLocation}
                        onToggleContactCenterDialog={this.onToggleContactCenterDialog}
                        onToggleShareLocationDialog={this.onToggleShareLocationDialog}
                        onBackClick={this.onBackClick} />
                }
            </div>
        )
    }
}

export default LocationDetail;



// WEBPACK FOOTER //
// ./src/components/locator/LocationDetail.js